import { render, staticRenderFns } from "./GridPromotedBuyboxRedesignExp.vue?vue&type=template&id=74f932d5&scoped=true"
import script from "./GridPromotedBuyboxRedesignExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPromotedBuyboxRedesignExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridPromotedBuyboxRedesignExp.vue?vue&type=style&index=0&id=74f932d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f932d5",
  null
  
)

export default component.exports